import type { SxStyle } from '@aibees/shared/theme';

export const rotate: SxStyle = {
  transform: 'scaleX(-1)',
};
